import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {makeStyles} from '@material-ui/core/styles';
import FancyDialog from 'components/FancyDialog';
import SlideUpTransition from 'components/SlideUpTransition';
import {useUniqueModal} from 'hooks/unique-modal';
import {useModal} from 'mui-modal-provider';
import React, {useCallback} from 'react';
import {createButtonStyles} from 'utils/material-button';

const useStyles = makeStyles((theme) => ({
  ...createButtonStyles(theme),
}));

export function useConfirmModal() {
  const classes = useStyles();
  const {showModal} = useModal();
  const {showModal: showUniqueModal} = useUniqueModal();

  return useCallback(
    (title, content, onConfirm, onCancel, options) => {
      options = {
        loadingModal: false,
        noLabel: 'خیر',
        yesLabel: 'بلی',
        hideAfter: 0,
        ...options,
      };

      let fnShowModal;
      const argsArray = [];

      if (options.id) {
        fnShowModal = showUniqueModal;
        argsArray.push(options.id);
      } else {
        fnShowModal = showModal;
      }

      const confirmationModal = fnShowModal.apply(this, [
        ...argsArray,
        FancyDialog,
        {
          title,
          content,
          actions: [
            <Button
              onClick={async () => {
                confirmationModal.hide();
                if (onCancel) {
                  let loadingModal;
                  try {
                    if (options.loadingModal) {
                      loadingModal = showModal(FancyDialog, {
                        content: <CircularProgress />,
                      });
                    }
                    await onCancel();
                  } finally {
                    if (loadingModal) {
                      loadingModal.hide();
                    }
                  }
                }
              }}
              className={classes.textError}
              size="large"
            >
              {options.noLabel}
            </Button>,
            <Button
              onClick={async () => {
                confirmationModal.hide();
                let loadingModal;
                try {
                  if (options.loadingModal) {
                    loadingModal = showModal(FancyDialog, {
                      content: <CircularProgress />,
                    });
                  }
                  await onConfirm();
                } finally {
                  if (loadingModal) {
                    loadingModal.hide();
                  }
                }
              }}
              color="primary"
              size="large"
            >
              {options.yesLabel}
            </Button>,
          ],
          seconds: Math.floor(options.hideAfter / 1000),
          disableBackdropClick: options.disableBackdropClick,
          disableEscapeKeyDown: options.disableEscapeKeyDown,
          TransitionComponent: SlideUpTransition,
        },
      ]);

      if (options.hideAfter > 0) {
        setTimeout(confirmationModal.hide, options.hideAfter);
      }
    },
    [classes.textError, showModal, showUniqueModal],
  );
}
